
import styles from './ProductSkeleton.module.css';

export const ProductSkeleton = () => {
    return (
        <div className={styles.skeletonContainer}>
            {/* Left: Gallery Skeleton */}
            <div className={styles.galleryColumn}>
                <div className={styles.galleryImage} />
            </div>

            {/* Right: Info Skeleton */}
            <div className={styles.infoColumn}>
                {/* Title */}
                <div className={`${styles.skeletonText} ${styles.title}`} />
                {/* Price */}
                <div className={`${styles.skeletonText} ${styles.price}`} />
                {/* Short Description */}
                <div className={`${styles.skeletonText} ${styles.description}`} />

                {/* Options Mockup */}
                <div className={styles.options}>
                    <div className={`${styles.skeletonText} ${styles.optionLabel}`} />
                    <div className={`${styles.skeletonText} ${styles.optionInput}`} />

                    <div className={`${styles.skeletonText} ${styles.optionLabel}`} />
                    <div className={`${styles.skeletonText} ${styles.optionInput}`} />
                </div>

                {/* Add to Cart Button */}
                <div className={`${styles.skeletonText} ${styles.button}`} />
            </div>
        </div>
    );
};
